export default class ArrayHelper {
  static isEmpty(array) {
    return JSON.stringify(array) === '[]';
  }

  static filterUnique(array) {
    return array.filter((item, index) => array.indexOf(item) === index);
  }

  static containsObjectsOnly(array) {
    return array.every(item => item instanceof Object);
  }

  static mapToNumbers(array) {
      return Array.isArray(array) ? array.map(Number) : [];
  }

  static mapToStrings(array) {
      return Array.isArray(array) ? array.map(String) : [];
  }

  static range(start, end, step) {
    const length = Math.floor((end - start) / step) + 1;
    return Array.from({ length }, (v, k) => (k * step) + start);
  }
}
